import { render, staticRenderFns } from "./ChallengeFreeText.vue?vue&type=template&id=c1a27e32&scoped=true&lang=pug&"
import script from "./ChallengeFreeText.vue?vue&type=script&lang=js&"
export * from "./ChallengeFreeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a27e32",
  null
  
)

export default component.exports